import { FC } from "react";
import { WebsiteDemoWidgetView } from "../../../../modules/widgets/views/website-demo-widget-view/website-demo-widget-view";

export const WebsiteDemoWidgetRoute: FC = () => {
    return (
        <WebsiteDemoWidgetView />
    )
}